/**
 * InstaText — writing assistant
 *
 * Its first web-accessible-resource entry exposes `js/alertMessages.json` and `images/*`
 * to `<all_urls>` with no `use_dynamic_url`, so both are fetchable from any page at a
 * fixed URL. (Two further WAR entries scope `overleaf.js` / `gdocs.js` to their own
 * sites, but we don't need them.) The 128px action icon is the cleanest signal — an
 * image, so it loads through `probeImage` with no CORS grant — and the vendor-named
 * `alertMessages.json` corroborates it.
 *
 * Manifest verified against version 1.4.3.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'immpagioobbjjlckfakmgpnbhheamcbi';

export const instaText: ExtensionDefinition = {
  id: ID,
  name: 'InstaText',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Exposes images/* and js/alertMessages.json to <all_urls> with no dynamic URL. The ' +
    'icon loads without a CORS grant and the JSON corroborates; detection is conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon-128x128.png via <img> — exposed to every origin and readable ' +
        'without a CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/icon-128x128.png'),
    },
    {
      id: 'war-alert-messages-json',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/alertMessages.json — a vendor-named data file exposed to <all_urls>, ' +
        'independent of the icon path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/alertMessages.json'),
    },
    {
      id: 'war-icon-16',
      kind: 'web-accessible-resource',
      description: 'Load images/icon-16x16.png via <img> — a second image path corroborator.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icon-16x16.png'),
    },
  ],
};
